import React from 'react';
import { VolumeXIcon, EyeOffIcon, MessageSquareOffIcon, UserXIcon, BrainIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <VolumeXIcon className="w-8 h-8 text-gold" data-id="element-71" />,
    text: 'Estás en una reunión o en una fiesta y tienes algo brillante que decir... pero te lo guardas. El momento pasa, alguien más lo dice, y todos lo celebran. Tú te quedas en silencio, frustrado contigo mismo.'
  }, {
    icon: <EyeOffIcon className="w-8 h-8 text-gold" data-id="element-72" />,
    text: 'Entras a un lugar y es como si fueras invisible. Nadie te nota, nadie te busca. Te quedas en una esquina esperando que alguien se acerque, pero nunca pasa.'
  }, {
    icon: <MessageSquareOffIcon className="w-8 h-8 text-gold" data-id="element-73" />,
    text: 'Escribes un mensaje, lo lees diez veces, lo envías... y te dejan en visto. O peor: te responden con un "jaja sí" que mata cualquier conversación. Sientes que no sabes conectar.'
  }, {
    icon: <UserXIcon className="w-8 h-8 text-gold" data-id="element-74" />,
    text: 'Siempre terminas siendo "el buen amigo". Eres atento, respetuoso, interesante... pero nunca te ven como algo más. Y no entiendes qué estás haciendo mal.'
  }, {
    icon: <BrainIcon className="w-8 h-8 text-gold" data-id="element-75" />,
    text: 'Ves a otros hombres que no son más inteligentes ni más atractivos que tú, pero tienen algo que atrae a las personas como un imán. Y te preguntas: ¿qué tienen ellos que yo no?'
  }];
  return <section className="py-12 bg-surface-primary relative border-t border-surface-border" data-id="element-76">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <div className="text-center mb-10" data-id="element-78">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-79">
            ¿Te suena <span className="text-gold" data-id="element-80">familiar?</span>
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full mb-4" data-id="element-81"></div>
          <p className="font-body text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-82">
            Si marcaste aunque sea{' '}
            <span className="text-gold font-bold" data-id="element-83">UNO</span> de estos puntos...
            este protocolo fue diseñado exactamente para ti.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-84">
          {problems.map((problem, index) => <div key={index} className={`bg-surface-card p-8 rounded-xl border border-surface-border flex flex-col items-start ${index === 4 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-85">
              <div className="p-3 bg-surface-elevated rounded-lg mb-6 border border-gold/20" data-id="element-86">
                {problem.icon}
              </div>
              <p className="font-body text-gray-300 text-lg leading-relaxed" data-id="element-87">
                {problem.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}